/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const requestEmailOTPRequestSchema = z
	.object({
		email: z.email().min(1),
	})
	.describe("Сериализатор запроса ОТП-кода для обновления email.");
